import { useEffect, useState } from "react";
import api from "../lib/api";

/**
 * TermsViewModal — visualização somente-leitura dos Termos de Uso vigentes
 * (usado pelo link "Termos de Uso" no wizard de cadastro público). Sem
 * ação de aceite — isso é feito pelo checkbox do próprio formulário.
 */
const TermsViewModal = ({ open, onClose }) => {
    const [terms, setTerms] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!open) return;
        let alive = true;
        setLoading(true);
        api.get("/public/terms")
            .then((res) => { if (alive) setTerms(res); })
            .catch(() => { if (alive) setTerms(null); })
            .finally(() => { if (alive) setLoading(false); });
        return () => { alive = false; };
    }, [open]);

    if (!open) return null;

    return (
        <div
            data-testid="terms-view-modal"
            onClick={onClose}
            className="fixed inset-0 z-[90] bg-black/80 backdrop-blur-sm flex items-center justify-center p-4"
        >
            <div
                onClick={(e) => e.stopPropagation()}
                className="w-full max-w-lg rounded-3xl border border-white/10 bg-slate-950 shadow-2xl overflow-hidden"
            >
                <div className="p-6 border-b border-white/5 flex items-start justify-between">
                    <div>
                        <div className="text-[10px] uppercase tracking-[0.3em] text-amber-300">Kinng.app</div>
                        <h2 className="salon-heading text-2xl text-white mt-1">Termos de Uso</h2>
                        {terms?.version && (
                            <p className="text-xs text-slate-500 mt-1">Versão {terms.version}</p>
                        )}
                    </div>
                    <button
                        onClick={onClose}
                        data-testid="terms-view-close-btn"
                        className="h-10 w-10 min-h-[44px] min-w-[44px] rounded-full bg-white/5 hover:bg-white/10 text-white transition-all shrink-0"
                    >
                        <i className="fa-solid fa-xmark"></i>
                    </button>
                </div>
                <div className="p-6 max-h-[50vh] overflow-y-auto text-sm text-slate-300 whitespace-pre-wrap leading-relaxed">
                    {loading ? (
                        <div className="text-slate-500">Carregando…</div>
                    ) : terms?.content ? (
                        terms.content
                    ) : (
                        <div className="text-slate-500">Termos ainda não publicados.</div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TermsViewModal;
